import { createFileRoute } from '@tanstack/react-router';
import { UserDetailPage } from '../../features/users/UserDetailPage.jsx';

function UserRoute() {
  const { userId } = Route.useParams();
  return <UserDetailPage key={userId} userId={userId} />;
}

export const Route = createFileRoute('/_app/users/$userId')({ component: UserRoute });
